import React, { useState, useContext, useEffect } from "react";
import { Formik } from "formik";
import { Table, Empty, Button, Space, Popconfirm } from "antd";

//import dayjs from "dayjs";

import * as Yup from "yup";
import ErrorMessage from "../components/ErrorMessage";

import authClient from "../api/authClient";
import AuthContext from "../auth/context";

import "antd/dist/antd.css";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const columns = [
  {
    title: "Nom",
    dataIndex: "nom",
    key: "nom",
    sorter: (a, b) => a.nom.localeCompare(b.nom),
  },
  {
    title: "Prénom",
    dataIndex: "prenom",
    key: "prenom",
    sorter: (a, b) => a.prenom.localeCompare(b.prenom),
  },
  {
    title: "Mail",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Profil",
    dataIndex: "profil",
    key: "profil",
  },
  {
    title: "Actif ",
    dataIndex: "actif",
    key: "actif",
    render: (text, record) =>
      record.actif ? (
        <span className={"badge badge-success-lighten p-1"}>OUI</span>
      ) : (
        <span className={"badge badge-danger-lighten p-1"}>NON</span>
      ),
  },
];

const validationSchema = Yup.object().shape({
  login: Yup.string().required("L'identifiant est obligatoire"),
  nom: Yup.string().required("Le nom est obligatoire"),
  prenom: Yup.string().required("Le prénom est obligatoire"),
  email: Yup.string()
    .email("Le format de l'email est incorrect")
    .required("L'email est obligatoire"),
});

const Utilisateurs = () => {
  const [loading, setLoading] = useState(false);
  const [listeUsers, setListeUsers] = useState([]);

  const authContext = useContext(AuthContext);

  useEffect(() => {
    lancerRecherche();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const lancerRecherche = async (values) => {
    setLoading(true);

    const retour = await authClient.getUsers(values);

    setLoading(false);

    if (!retour.ok) {
      if (retour.status === 401 || retour.status === 403) {
        localStorage.removeItem("currentUser");
        authContext.setUser(null);
      } else {
        toast.error("Une erreur inattendue est survenue");
      }
    } else {
      if (retour.data) {
        setListeUsers(retour.data);
      } else {
        setListeUsers(undefined);
      }
    }
  };

  const creerUser = async (values) => {
    setLoading(true);

    //  console.log("filters", values);

    const retour = await authClient.addUser(values);

    setLoading(false);

    if (!retour.ok) {
      if (retour.status === 401 || retour.status === 403) {
        localStorage.removeItem("currentUser");
        authContext.setUser(null);
      } else {
        toast.error(
          "Une erreur est survenue lors de la création de l'utilisateur"
        );
      }
      console.log(retour);
    } else {
      window.$("#userModal").modal("hide");
      toast.success("L'utilisateur a été créé avec succès");
      lancerRecherche();
    }
  };

  const adminColumns = [
    ...columns,
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Popconfirm
            title="Etes vous sûr de vouloir réinitialiser le mot de passe de cet utilisateur ?"
            onConfirm={() => handleReinitPassword(record.id)}
            okText="Oui, je suis sûr"
            cancelText="Non"
          >
            <a href="#">Réinitialiser mot de passe</a>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleInitNewUser = () => {
    window.$("#userModal").modal("show");
  };

  const handleReinitPassword = async (idUser) => {
    setLoading(true);

    const retour = await authClient.initPassword(idUser);

    setLoading(false);

    if (!retour.ok) {
      if (retour.status === 401 || retour.status === 403) {
        localStorage.removeItem("currentUser");
        authContext.setUser(null);
      } else {
        toast.error("Une erreur inatendue est survenue");
      }
    } else {
      lancerRecherche();
      // Confirmer l'action
      toast.success("Le mot de passe a été réinitialisé avec succès");
    }
  };

  return (
    <>
      <ToastContainer />
      <div
        className="modal fade"
        id="userModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edition d'un utilisateur
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <Formik
              validationSchema={validationSchema}
              initialValues={{
                login: "",
                nom: "",
                prenom: "",
                email: "",
              }}
              onSubmit={(values) => {
                creerUser(values);
              }}
            >
              {({
                handleChange,
                handleSubmit,
                errors,
                setFieldTouched,
                touched,
                setFieldValue,
                setErrors,
                values,
              }) => (
                <>
                  <div className="modal-body">
                    <div className="form-group mb-1">
                      <label htmlFor="loginUser">Identifiant</label>
                      <input
                        autoFocus
                        value={values["login"]}
                        onChange={handleChange("login")}
                        onBlur={() => setFieldTouched("login")}
                        className="form-control"
                        id="loginUser"
                        type="text"
                      />
                      <ErrorMessage
                        error={errors.login}
                        visible={touched.login}
                      />
                    </div>
                    <div className="form-group mb-1">
                      <label htmlFor="nomUser">Nom</label>
                      <input
                        value={values["nom"]}
                        onChange={handleChange("nom")}
                        onBlur={() => setFieldTouched("nom")}
                        className="form-control"
                        id="nomUser"
                        type="text"
                      />
                      <ErrorMessage error={errors.nom} visible={touched.nom} />
                    </div>
                    <div className="form-group mb-1">
                      <label htmlFor="prenomUser">Prénom</label>
                      <input
                        value={values["prenom"]}
                        onChange={handleChange("prenom")}
                        onBlur={() => setFieldTouched("prenom")}
                        className="form-control"
                        id="prenomUser"
                        type="text"
                      />
                      <ErrorMessage
                        error={errors.prenom}
                        visible={touched.prenom}
                      />
                    </div>
                    <div className="form-group mb-1">
                      <label htmlFor="emailUser">Email</label>
                      <input
                        value={values["email"]}
                        onChange={handleChange("email")}
                        onBlur={() => setFieldTouched("email")}
                        className="form-control"
                        id="emailUser"
                        type="text"
                      />
                      <ErrorMessage
                        error={errors.email}
                        visible={touched.email}
                      />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <Button
                      loading={loading}
                      className="btn btn-secondary"
                      type="primary"
                      data-dismiss="modal"
                    >
                      Annuler
                    </Button>
                    <Button
                      loading={loading}
                      className="btn btn-primary"
                      type="primary"
                      onClick={handleSubmit}
                    >
                      Valider
                    </Button>
                  </div>
                </>
              )}
            </Formik>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box">
            <h4 className="page-title">Utilisateurs</h4>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="card mb-4">
            <div className="card-header">Critères de recherche</div>
            <div className="card-body">
              <Formik
                initialValues={{
                  nom: "",
                  prenom: "",
                }}
                onSubmit={(values) => {
                  lancerRecherche(values);
                }}
              >
                {({
                  handleChange,
                  handleSubmit,
                  errors,
                  setFieldTouched,
                  touched,
                  setFieldValue,
                  setErrors,
                  values,
                }) => (
                  <>
                    <div className="form-row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="inputFirstName">Nom :</label>
                          <input
                            value={values["nom"]}
                            onChange={handleChange("nom")}
                            className="form-control"
                            id="inputFirstName"
                            type="text"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="inputLastName">Prénom :</label>
                          <input
                            value={values["prenom"]}
                            onChange={handleChange("prenom")}
                            className="form-control "
                            id="inputLastName"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group d-flex align-items-center justify-content-end mt-2 mb-0 ">
                      <Button
                        loading={loading}
                        className="btn btn-success mr-2"
                        type="primary"
                        onClick={handleInitNewUser}
                      >
                        Ajouter un utilisateur
                      </Button>
                      <Button
                        loading={loading}
                        className="btn btn-primary"
                        type="primary"
                        onClick={handleSubmit}
                      >
                        Rechercher
                      </Button>
                    </div>
                  </>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="card mb-4">
            <div className="card-header">Liste des Utilisateurs</div>
            <div className="card-body">
              <div className="table-responsive">
                <Table
                  rowKey="id"
                  loading={loading}
                  columns={
                    authContext.user.profil !== "ADMIN" ? columns : adminColumns
                  }
                  dataSource={listeUsers}
                  locale={{
                    sortTitle: "trier",
                    cancelSort: "Cliquez pour annuler le tri",
                    triggerAsc: "Cliquez pour un tri ascendant",
                    triggerDesc: "Cliquez pour un tri descendant",
                    emptyText: (
                      <Empty
                        image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                        imageStyle={{
                          height: 60,
                        }}
                        description={<span>Aucun Utilisateur</span>}
                      ></Empty>
                    ),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Utilisateurs;
